export const FeatureImage = ({
  src,
  dataTestId,
}: {
  src: string;
  dataTestId?: string;
}) => (
  <div className="col-span-6 flex justify-center overflow-hidden rounded-[10px] lg:col-span-7">
    <img
      data-testid={dataTestId}
      alt=""
      loading="lazy"
      src={src}
      className="object-cover"
    />
  </div>
);
